/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowBoardGameTournamentTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowBoardGameTournament,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let the Tournament Begin!",
    "Game On for the Championship!",
    "Board Game Showdown!",
  ],
  title: "Board Game Tournament",
  description: "Organize a competitive board game tournament.",
  longDescription:
    "Gather your friends for an exciting board game tournament! Choose a date, select the games to compete in, and decide on prizes!",
  emoji: "♟",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Board Game Tournament",
          emoji: "♟",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the tournament?",
          emoji: "📅",
          completeAction: {
            question: "Decide on games to compete in?",
            description:
              "What board games should we include in the tournament?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What games should we play?",
                emoji: "🎲",
                completeAction: {
                  question: "Decide on prizes?",
                  description: "What prizes should we offer for the winners?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What prizes should we have?",
                      emoji: "🏆",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "May the Best Player Win!",
    outroDescription:
      "Your board game tournament plans are set! Enjoy the competition!",
  },
};
